import { type PublicEventContentObject, createPublicEventContentObject } from 'models';
import { useQuery } from 'query';
import type { PublicEventContentObjectDataObject } from 'models/service';

import { getEvent } from '../services';

import { getEventDetailQueryKey } from './keys';

export const useEventPublicQuery = (
  { eventId, invitationToken }: { eventId: string; invitationToken?: string },
  options?: { throwOnError?: boolean },
) =>
  useQuery<PublicEventContentObject>({
    async queryFn() {
      const { data: eventContenObject } = await getEvent<PublicEventContentObjectDataObject>(eventId, {
        invitation_token: invitationToken,
      });

      return createPublicEventContentObject(eventContenObject);
    },
    queryKey: getEventDetailQueryKey({ id: eventId, invitationToken, view: 'public' }),
    throwOnError: true,
    ...options,
  });
